import { cn } from "@/lib/utils";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => EMAIL_REGEX.test(String(value || "").trim());

export const getFieldErrorClass = (hasError) =>
  hasError
    ? "border-destructive/60 bg-red-50/80 text-slate-900 focus-visible:ring-destructive"
    : "";

export const getFieldMessageClass = (isError = false) =>
  cn("text-xs leading-5", isError ? "text-destructive" : "text-muted-foreground");
